import React from 'react';
import {Grid,Divider} from '@material-ui/core'
import {useSelector, useDispatch} from 'react-redux'
import {isEmpty} from 'lodash'
import CheckBoxInput from '../Inputs/CheckBoxInput'
import CheckBoxInputAnsvarig from '../Inputs/CheckBoxInputAnsvarig'
import CheckBoxDatum from '../Inputs/CheckBoxDatum'
import CheckBoxInputTaggning from '../Inputs/CheckBoxInputTaggning'
import CheckBoxInputArendeStatus from '../Inputs/CheckBoxInputArendeStatus'
import CheckBoxInputArendePrio from '../Inputs/CheckBoxInputArendePrio'
import CheckBoxInputArendeType from '../Inputs/CheckBoxInputArendeType'
import {getKontoArendeFriaFalt} from 'actions'
import IntlMessages from 'util/IntlMessages';
function ArendeSection(props) {
    const dispatch = useDispatch()
    const KontoArendeFI = useSelector(state => state.accountsData.KontoArendeFI)
    const Afid = useSelector(state => state.auth.authUser.user_Afid)
    const Flags = useSelector(state => state.accountsData.Flags) 
    const onChangeMstate=(Chips)=>{
        console.log(Chips)
    }
    React.useEffect(()=>{
        dispatch(getKontoArendeFriaFalt(Afid))
    },[])
    console.log(KontoArendeFI,"KontoArendeFI")
    return (<>
           <Grid container direction="row" alignItems="center" className='mt-2 pt-2 pl-2' style={{maxHeight:460,minHeight:120,overflowY:"auto"}}>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Ärendenummer" MetaN={"Arende_ArendeNr"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAnsvarig Meta="Skapad av" MetaN={"Arende_User"}  disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAnsvarig Meta="Ansvarig" MetaN={"Arende_Ansvarig"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputAnsvarig Meta="Ägare" MetaN={"Arende_Ansvarig1"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputArendeStatus Meta="Status"  MetaN={"Arende_Status"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputArendePrio Meta="Prio" MetaN={"Arende_Prio"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputArendeType Meta="Ärendetyp" MetaN={"Arende_ArendeTyp"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Kategori" MetaN={"Arende_Kategori"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Telefonnummer" MetaN={"Arende_Telefonnummer"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Beskrivning" MetaN={"Arende_Beskrivning"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Förslag på åtgärd" MetaN={"Arende_Atgrad"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInputTaggning Meta="Taggar" MetaN={"Arende_Taggar"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Flöde" MetaN={"Arende_Flode"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item className={"p-2"}  xs={12} >
            <Divider/>
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Ändrad" MetaN={"Arende_UpdateDate"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={12} md={6} >
           <CheckBoxDatum Meta="Skapad" MetaN={"Arende_SkapadDate"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           {Afid === 723812768 || Afid=== 1001?<>           
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Medlemsbåt"  MetaN={"Arende_Nmss_MedlemBoot"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Båttillverkare" MetaN={"Arende_Nmss_tillverkare"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Lat"  MetaN={"Arende_Nmss_Lat"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Long" MetaN={"Arende_Nmss_Long"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Skadeplats" MetaN={"Arende_Nmss_Skadeplats"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Region" MetaN={"Arende_Nmss_Region"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Assistansbåtar" MetaN={"Arende_Nmss_AssistanBoot"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Larmorsak" MetaN={"Arende_Nmss_Larmorsak"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Skadeärendenr" MetaN={"Arende_Nmss_SkadeArendeNr"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>

           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Uppskattat pris (ex moms)" MetaN={"Arende_Nmss_Upris"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Verkligt pris" MetaN={"Arende_Nmss_Vpris"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
           <CheckBoxInput Meta="Faktura" MetaN={"Arende_Nmss_Faktura"} disabled={false} Value={true} 
           onChangeMstate={props.onChangeMstate} 
           Mstate={props.Chips}
           />
           </Grid>
           </>:""}
           <Grid item className={"p-2"}  xs={12} >
            <Divider/>
           </Grid>
           <Grid item  className={"pt-1"}  xs={12} md={12} ><IntlMessages id="FreeInputs"/></Grid>
            {!isEmpty(KontoArendeFI)?
                KontoArendeFI.map(item=>(
                    !isEmpty(item.Falt.filter(item2=>parseInt(item2.inRapport) === 1))?
                    <>
                    <Grid item  className={"pt-1"}  xs={12} md={12} >{item.CateName}</Grid>
                    {
                        item.Falt.filter(item2=>parseInt(item2.inRapport) === 1).map(item1=>{
                            return  <Grid item  style={{height:46}} className={"pt-1"}  xs={6} md={3} lg={2} >
                            <CheckBoxInput Meta={`${item.CateId} ${item1.Meta}`} MetaN={`Arende_FriaFalt_${item.CateId}_${item1.Meta}`} disabled={false} Value={true} 
                            onChangeMstate={props.onChangeMstate} 
                            Mstate={props.Chips}
                            />
                            </Grid>
                        })
                    }
                    </>
                    :""
                ))
            :""}
           </Grid>
        </>
    );
}

export default ArendeSection;